// Libs
import { SyntheticEvent, useMemo, useState } from 'react';
import { AutocompleteInputChangeReason } from 'ui-components';
// App
import { ShopSearchResult, useGetShop, useSearchShopsByName } from 'app-shared/lib/api/shop-administration/shop';
import { switchCurrentUserShop } from 'app-shared/lib/api/shop-administration/user';
import { SearchHookReturn } from './search-hook-return.interface';
import { addMissingShop, buildSwitchedShopUrl, excludeShop, toShopSearchResult } from './search.utils';

export const useShopSwitchSearch = (shopId: number): SearchHookReturn => {
  const { data: shop } = useGetShop(shopId);
  const { executeSearch, searchResults, isSearchLoading } = useSearchShopsByName();
  const [searchText, setSearchText] = useState('');
  const [isListRequested, setListRequested] = useState(false);
  const [isSearchTyped, setSearchTyped] = useState(false);
  const [isSwitching, setSwitching] = useState(false);
  const currentShop = useMemo(() => toShopSearchResult(shop), [shop]);

  const shopOptions = addMissingShop(searchResults, currentShop);
  const isListOpen = isListRequested && isSearchTyped;

  const openList = () => {
    setListRequested(true);
  };

  const closeList = () => {
    setListRequested(false);
  };

  const keepOtherShops = (shops: ShopSearchResult[]) => {
    const otherShops = excludeShop(shops, shopId);

    return otherShops;
  };

  const handleInputChange = (_event: SyntheticEvent, newSearchText: string, reason: AutocompleteInputChangeReason) => {
    const isTypedByUser = reason === 'input';

    setSearchText(newSearchText);
    setSearchTyped(isTypedByUser);

    if (isTypedByUser) {
      executeSearch(newSearchText);
    }
  };

  const handleShopSelected = async (_event: SyntheticEvent, selectedShop: ShopSearchResult | null) => {
    if (!selectedShop) return;

    setSwitching(true);

    try {
      await switchCurrentUserShop({ shopId: selectedShop.id });
      window.location.assign(buildSwitchedShopUrl(window.location.pathname, selectedShop.id));
    } catch {
      setSwitching(false);
    }
  };

  return {
    currentShop,
    shopOptions,
    searchText,
    isListOpen,
    isSearchLoading,
    isSwitching,
    openList,
    closeList,
    keepOtherShops,
    handleInputChange,
    handleShopSelected,
  };
};

export default useShopSwitchSearch;
